/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'category': {
    width: 11,
    height: 10,
    viewBox: '0 0 11 10',
    data: '<path pid="0" d="M.4 2.169l.059.002h10.036l.025.001c.024.006.052.02.083.027h.002l.01.001.01.006.054.03c.005.005.012.009.018.013l.01.006.02.021a.432.432 0 0 1 .047.05l.053.088.002.006.001.003.017.053a.847.847 0 0 1 .011.052l.002.012a.507.507 0 0 1 .002.042v.046l-.002.045V9.52c-.013.48-.414.48-.416.48H.396L.37 9.999a.861.861 0 0 1-.118-.025L.241 9.97c-.017-.01-.035-.018-.052-.027l-.045-.03H.14l-.04-.041-.036-.037c-.003-.004-.007-.008-.009-.013a.403.403 0 0 1-.023-.037A.684.684 0 0 1 0 9.583V2.455c0-.003.002-.005.004-.007a.18.18 0 0 0 .012-.034l.019-.03.025-.04a.044.044 0 0 0 .005-.01c.028-.025.052-.054.081-.081l.046-.03.049-.026c-.037.007.007-.002.015-.005.03-.01.06-.016.09-.022l.02-.001zM3.814 0c.17 0 .333.08.436.216L5.382 1.7l.004.005H.452c-.03 0-.058-.003-.088-.001a.915.915 0 0 0-.362.094V.512C.002.23.234 0 .516 0h3.3z" _fill="#848484" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/category.js